import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import NoImage from "../asset/noimage.png";
import { FaCalendarAlt, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AllBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchAllBlogs = async () => {
    try {
      const response = await fetch(SummaryApi.getActiveBlog.url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();

      if (response.ok && result.status && Array.isArray(result.data)) {
        setBlogs(result.data);
      } else {
        console.error("Unexpected API response:", result);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllBlogs();
  }, []);

  // Calculate total pages
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  // Get blogs to display on current page
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const getCategory = (category) => (category?.trim() ? category : "No Category");
  const getFullMediaUrl = (relativePath) => {
    if (!relativePath) return null;
    const normalized = relativePath.replace(/\\/g, "/");
    const base = SummaryApi.Images.url.replace("/api", "");
    return `${base}/${normalized}`;
  };

  // Handlers for pagination buttons
  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  if (loading)
    return <p className="text-center text-gray-500 dark:text-gray-400">Loading...</p>;
  if (!blogs.length)
    return <p className="text-center text-gray-500 dark:text-gray-400">No blogs found.</p>;

  return (
    <>
      {/* Back button - mobile only */}
      <button
        onClick={() => navigate(-1)}
        className="fixed top-20 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white dark:bg-gray-800 rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:border-gray-700 lg:hidden"
        aria-label="Go back"
      >
        <FaArrowLeft className="text-black dark:text-white" />
      </button>

      <section className="pt-5 px-4 max-w-7xl mx-auto mb-5">
        <h2 className="text-4xl font-extrabold text-blue-900 dark:text-blue-400 mb-8 text-center">
          All Blogs
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentBlogs.map((blog) => (
            <div
              key={blog.blog_id}
              onClick={() => navigate(`/blog-details/${btoa(blog.blog_id.toString())}`)}
              className="bg-white dark:bg-[#111827] p-5 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 cursor-pointer hover:shadow-md transition"
            >
              <img
                src={getFullMediaUrl(blog.blog_image) || NoImage}
                alt={blog.title}
                className="rounded-lg w-full h-48 object-cover mb-4"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImage;
                }}
              />
              <p className="text-sm mb-2 flex items-center gap-2 text-gray-600 dark:text-gray-400">
                <FaCalendarAlt />
                {new Date(blog.blog_date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
                <span className="bg-orange-100 text-orange-600 text-[10px] px-2 py-1 rounded ml-auto">
                  {getCategory(blog.category)}
                </span>
              </p>
              <h3 className="text-blue-900 dark:text-blue-400 font-semibold text-lg">{blog.title}</h3>
            </div>
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-center items-center gap-4 mt-8">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className={`px-4 py-3 rounded-full font-semibold ${
              currentPage === 1
                ? "bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
                : "bg-blue-900 hover:bg-blue-800 text-white hover:bg-[#100F36]"
            }`}
          >
            Prev
          </button>

          <span className="text-gray-700 dark:text-gray-300 font-semibold">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`px-4 py-3 rounded-full font-semibold ${
              currentPage === totalPages
                ? "bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
                : "bg-blue-900 hover:bg-blue-800 text-white hover:bg-[#100F36]"
            }`}
          >
            Next
          </button>
        </div>
      </section>
    </>
  );
};

export default AllBlogs;
